import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { I18nextProvider } from 'react-i18next';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import { i18n } from './i18n';
import { router } from './router';
import { store } from './store';
import * as Sentry from '@sentry/react';

import { initWindowFeatureFlags } from '@/utils/featureFlags';

import './global.css';

initWindowFeatureFlags();

Sentry.init({
  dsn: 'https://92f8d9a2ec81acb7d2dcf29a1ccf8d40@o4509068468158464.ingest.us.sentry.io/4509068471042048',
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <HelmetProvider>
      <Provider store={store}>
        <I18nextProvider i18n={i18n}>
          <RouterProvider router={router} />
        </I18nextProvider>
      </Provider>
    </HelmetProvider>
  </StrictMode>
);
